module.exports = __webpack_public_path__ + "static/media/Administrative Penalty Order - Ali.05253829.pdf";